/**
 * Coordonnées de contact affichées au client.
 *
 * Une seule adresse, `contact@zeyonefit.com` (chantier C, décision du 06/10) : c'est
 * aussi l'expéditeur des emails (authentification, fin d'essai), si bien qu'une
 * réponse à un email arrive au même endroit qu'un « Écris-moi » de l'app. Elle est
 * reçue par le routage d'emails de Cloudflare, qui la renvoie vers la boîte d'Adam.
 * Avant : `support@coaching-app.com` (adresse d'exemple, inexistante) dans les
 * Réglages et « Mon programme », et l'adresse personnelle d'Adam ailleurs.
 *
 * Q1 (prise de rendez-vous) n'est pas tranchée : l'appel découverte se demande par
 * email. `mailtoHref` est à remplacer par une URL Cal.com/Calendly pour l'appel le
 * jour où Q1 sera tranchée — il sert à l'écran de fin d'essai ET au diagnostic
 * (recommandation blessure).
 */
export const CONTACT_EMAIL = "contact@zeyonefit.com"

export function mailtoHref(subject: string, body?: string): string {
  const params = [`subject=${encodeURIComponent(subject)}`]
  if (body) params.push(`body=${encodeURIComponent(body)}`)
  return `mailto:${CONTACT_EMAIL}?${params.join("&")}`
}
